export default __webpack_public_path__ + "static/media/TWE.44425255.png";